import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import {
    Modal,
    Card,
    CardContent,
    CardActions,
    Grid,
    CardHeader,
    Divider,
    Typography,
    TextField,
    Switch,
    Button,
    colors
} from '@material-ui/core';
import { edit_agency, edit_admin } from '../../api/API';
import EditModal from './EditModal.css';
import ColorPicker from 'material-ui-color-picker'

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        // width: 700,
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%'
    },

    container: {
        marginTop: theme.spacing(3)
    },

    actions: {
        justifyContent: 'flex-end'
    },

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));


export default function EditAgency(props) {

    const { open, onClose, customer, className, ...rest } = props;
    const [password, setPassword] = useState(''); 
    const [password2, setPassword2] = useState('');
    const classes = useStyles();

    const [formState, setFormState] = useState(props.agency);

    if (!open) {
        return null;
    }

    const handleColorChange = event => {
        console.log(event);
        setFormState({
            ...formState,
            color: event
        });
    }
    const handleFieldChange = event => {
        event.persist();
        if (event.target.name == 'password') {
            setPassword(event.target.value);
            return;
        } else if (event.target.name == 'password2') {
            setPassword2(event.target.value);
            return;
        }

        if(event.target.name == 'short_name' && event.target.value.length > 5){
            return;
        }

        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        }));
    };

    const handleSubmit = async (event) => {
        let data = {
            ...formState,
            password: password,
            password2: password2
        }

        let res = await edit_agency(data);
        if (res.status) {
            onClose();
        } else {
            alert(res.message);
        }
    };

    return (
        <Modal
            onClose={onClose}
            open={open}
        >
            <Card
                {...rest}
                className={" edit_modal"}
            >
                <CardHeader
                    //   action={<GenericMoreButton />}
                    title="Edit Agency Detail"
                />
                <Divider />
                <form>
                    <CardContent>
                        <Typography
                            align="center"
                            gutterBottom
                            variant="h5"
                        >

                        </Typography>
                        <Grid
                            className={classes.container}
                            container
                            spacing={3}
                        >
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    onChange={handleFieldChange}
                                    value={formState.name}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Short Name"
                                    name="short_name"
                                    onChange={handleFieldChange}
                                    value={formState.short_name}
                                    variant="outlined"
                                />
                            </Grid>
                            {/* <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    onChange={handleFieldChange}
                                    value={formState.email}
                                    variant="outlined"
                                />
                            </Grid> */}
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Contact Number"
                                    name="contact"
                                    onChange={handleFieldChange}
                                    value={formState.contact}
                                    variant="outlined"
                                />
                            </Grid>



                            {/* <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Password *Leave blank if not changing"
                                    name="password"
                                    onChange={handleFieldChange}
                                    type="password"
                                    value={password}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Confirm Password"
                                    name="password2"
                                    onChange={handleFieldChange}
                                    type="password"
                                    value={password2}
                                    variant="outlined"
                                />
                            </Grid> */}
                            <Grid
                                item
                                md={6}
                                xs={12}
                                style={{
                                    height: 250
                                }}
                            >
                                <div style={{
                                    display: 'flex',

                                }}>
                                    <div style={{
                                        minWidth: 54,
                                        maxWidth: 54,
                                        height: 54,
                                        borderRadius: 27,
                                        backgroundColor: formState.color,
                                        marginRight: 10
                                    }}></div>
                                    <div
                                        style={{
                                            flexGrow: 1
                                        }}
                                    >
                                        <ColorPicker
                                            fullWidth
                                            label={formState.color ? formState.color : "-- select a color label --"}
                                            name="color"
                                            value={formState.color}
                                            onChange={handleColorChange}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                            </Grid>

                        </Grid>
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button
                            style={{
                                backgroundColor: "black"
                            }}
                            onClick={onClose}
                            variant="contained"
                        >
                            <CloseIcon className={classes.leftIcon} />
                            Close
                    </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                        >
                            <SaveIcon className={classes.leftIcon} />
                            Save
                    </Button>
                    </CardActions>
                </form>
            </Card>
        </Modal>
    )
}
